"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntlScope = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = require("../components/Typography");
const defaultValues = {
    bold: (chunks) => react_1.default.createElement(Typography_1.Typography, { weight: "bold" }, chunks),
    br: () => react_1.default.createElement("br", null)
};
const useIntlScope = (nsp) => {
    const intl = react_intl_1.useIntl();
    return (id, values) => {
        return intl.formatMessage({ id: `${nsp}${id}` }, { ...defaultValues, ...values });
    };
};
exports.useIntlScope = useIntlScope;
//# sourceMappingURL=useIntlScope.js.map